import React from 'react';
// Ensure your logo is at src/assets/logo.svg
import logo from './assets/logo.svg';

export default function App() {
  return (
    <div className="min-h-screen w-full flex flex-col items-center bg-[#F4F4F5] font-sans text-black overflow-x-hidden">
      
      {/* --- HERO SECTION --- */}
      <section className="w-full min-h-[90vh] flex flex-col items-center justify-center px-6 py-20 animate-fade-in">
        
        {/* HERO LOGO: Large high-impact size */}
        <div className="w-64 md:w-96 mb-8">
          <img src={logo} alt="éo logo" className="w-full h-auto select-none" />
        </div>

        <h1 className="text-xl md:text-2xl font-bold text-center max-w-lg leading-snug">
          The only AI doctors can trust in image-based medicine.
        </h1>
      </section>

      {/* --- VALUE PROPOSITION --- */}
      <section className="w-full min-h-[60vh] flex items-center justify-center px-6 md:px-12 max-w-7xl mx-auto py-24">
        <div className="text-3xl md:text-6xl font-bold leading-tight md:leading-[1.1] tracking-tight -ml-1 text-left">
          <div className="inline">
            
            {/* INLINE LOGO */}
            <span className="inline-block mr-2 md:mr-3">
              <img src={logo} alt="éo" className="h-[0.85em] w-auto inline-block align-baseline transform translate-y-1 md:translate-y-2 select-none" />
            </span>
            
            <span>is an AI co-pilot that integrates into daily image screening, </span>
            <span className="text-[#4ADE80]">learning from each doctor and encoding their expertise into on-demand AI models </span>
            <span>that boost diagnostic confidence and reduce errors.</span>
          </div>
        </div>
      </section>

      {/* --- MISSION SECTION --- */}
      <section className="w-full min-h-[80vh] flex flex-col items-center justify-center px-6 text-center max-w-5xl mx-auto py-20 space-y-20">
        
        {/* MISSION LOGO */}
        <div className="w-40 md:w-56">
          <img src={logo} alt="éo logo" className="w-full h-auto select-none" />
        </div>

        <div className="space-y-10 md:px-10">
          <p className="text-xl md:text-3xl font-bold leading-snug">
            Our mission is to pair expert human judgement with machine intelligence, enabling superior decisions on the world’s most challenging images.
          </p>

          <div className="space-y-6">
            <p className="text-lg md:text-2xl font-light text-gray-900 leading-relaxed">
              Partner with us to use Expert Guided Intelligence to image-based medicine to deliver the best care.
            </p>

            <p className="text-lg md:text-2xl font-light text-gray-900 leading-relaxed">
              Reach out to the CEO Jonathan Alexander Brown <br className="hidden md:block"/>
              <a href="mailto:jonathan@eovision.ai" className="text-blue-600 font-medium hover:underline decoration-2 underline-offset-4">
                jonathan@eovision.ai
              </a> to explore the opportunity.
            </p>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="w-full py-6 text-center text-gray-400 text-sm flex items-center justify-center gap-1">
        <span>&copy; {new Date().getFullYear()}</span>
        <img src={logo} alt="éo" className="h-3.5 w-auto opacity-60 mb-0.5 select-none" />
        <span>Vision. All rights reserved.</span>
      </footer>
    </div>
  );
}